"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeInput = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var utils_1 = require("../utils");
exports.DateRangeInput = react_1.default.forwardRef(function (_a, ref) {
    var value = _a.value, placeholder = _a.placeholder, onBlur = _a.onBlur, error = _a.error, autoFocus = _a.autoFocus, onFocus = _a.onFocus, onKeyPress = _a.onKeyPress;
    var _b = react_1.default.useState(value === null ? '' : utils_1.toDateFormat.numeric(new Date(value))), IValue = _b[0], setIValue = _b[1];
    var _c = react_1.default.useState(''), dateValue = _c[0], setDateValue = _c[1];
    react_1.default.useEffect(function () {
        var _a;
        setDateValue((_a = (value && utils_1.toDateFormat.numeric(new Date(value)))) !== null && _a !== void 0 ? _a : '');
    }, [value]);
    var handleOnChange = function (data) {
        setDateValue(data);
    };
    var handleOnBlur = function () {
        var currentAsDate = new Date(dateValue);
        if (utils_1.isValid(currentAsDate)) {
            setDateValue(utils_1.toDateFormat.numeric(currentAsDate));
            setIValue(utils_1.toDateFormat.numeric(currentAsDate));
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(currentAsDate);
        }
        else {
            setDateValue(IValue);
        }
    };
    var selectAllText = function (e) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        e.target.select();
    };
    return (react_1.default.createElement(__1.Tooltip, { open: error, text: error, direction: "b" },
        react_1.default.createElement(__1.Input, { onBlur: handleOnBlur, onKeyPress: onKeyPress, onChange: function (e, value) { return handleOnChange(value.value); }, error: error, onFocus: selectAllText, placeholder: placeholder, value: dateValue, icon: "event", iconPosition: "left", fluid: true, className: "m-0", autoFocus: autoFocus, inputRef: ref })));
});
//# sourceMappingURL=DateRangeInput.js.map